import * as React from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import CardItem from '../events/components/card_item'
import { Arrows } from './Arrows'
declare const I18n: any

type Event = {
  id: number
  title: string
  description: string
  slug: string
  cover_image_url?: string | null
  location?: string | null
  categories?: Category[]
  start_time?: string | null
  end_time?: string | null
  user_id?: number | null
  current_user_id?: number | null
}

type Props = {
  events: Event[]
  isFacilitator?: boolean
  isLearner?: boolean
  heading: string
  viewAllText: string
  viewAllUrl: string
  emptyStateText: string
  cardBackground?: 'primary' | 'secondary'
}

type State = {
  initialSettings: Record<string, any>
}

class UpcomingEventsSlider extends React.Component<Props, State> {
  private sliderRef: React.RefObject<Slider>

  constructor(props: Props) {
    super(props)

    this.sliderRef = React.createRef()

    this.state = {
      initialSettings: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      }
    }
  }

  getCoverImageUrl(coverImageData: string | null): string | null {
    if (!coverImageData || coverImageData === 'null') return null

    try {
      const imageData = JSON.parse(coverImageData)
      return imageData.id || null
    } catch {
      return null
    }
  }

  truncateText(text: string | undefined, maxLength: number = 150): string {
    if (!text || text === 'null') return ''

    const trimmed = text.trim()

    if (trimmed.length <= maxLength) {
      return trimmed
    }

    return trimmed.slice(0, maxLength) + '...'
  }

  handleDelete = (id: number) => {
  }

  render() {
    const {
      events,
      isFacilitator,
      isLearner,
      heading,
      emptyStateText,
      cardBackground = 'primary',
    } = this.props

    const items = events || []

    return (
      <div>
        <div className="resource-heading-container">
          <h2 className="slider-section-heading">
            {heading}
          </h2>
          {items.length > 0 && <Arrows sliderRef={this.sliderRef} />}
        </div>

        <div className="">
          {items && items.length > 0 ? (
            <div className="featured-resource-slider">
              <Slider ref={this.sliderRef} {...this.state.initialSettings}>
                {items.map((event, index) => {
                  return (
                    <div key={event.id} className="slider-card-wrapper">
                      <CardItem
                        cardBackground={cardBackground}
                        title={event.title}
                        description={event.description || ''}
                        targetRole="facilitator"   
                        index={index}
                        id={event.id}
                        slug={event.slug}
                        image={event.cover_image_url ?? undefined}
                        isFacilitator={isFacilitator}
                        isLearner={isLearner}
                        handleDelete={this.handleDelete}
                        location={event.location ?? undefined}
                        categories={event.categories}
                        start_time={event.start_time ?? undefined}
                        end_time={event.end_time ?? undefined}
                        user_id={event.user_id ?? undefined}
                        current_user_id={event.current_user_id ?? undefined}
                        type={I18n.t('models.event.view_event')}
                      />
                    </div>
                  )
                })}
              </Slider>
            </div>
          ) : (
            <div className="empty-state text-center">
              {emptyStateText}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default UpcomingEventsSlider